module.exports = "https://health.dajiuxing.com.cn/img/assets/personalInformation/SaveBackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FpersonalInformation%2FSaveBackground.png
// module id = 6gPg
// module chunks = 93